<script>
export default {
  name: "LogoMsg",
  data() {
    return {
      text: ''
    }
  }
}
</script>

<template>
  <view class='logo-msg'>
    <view class='logo'></view>
    <view class='text'>{{ text }}</view>
  </view>
</template>

<style scoped lang="scss" scoped>
.logo-msg {
  position: fixed;
  z-index: 999999999;
  top: 150rpx;
  left: 50%;
  transform: translateX(-50%);
  width: max-content;
  max-width: 80vw;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20rpx;
  padding: 20rpx;
  background: rgba(0, 0, 0, 0.666);
  border-radius: 20rpx;
  box-sizing: border-box;
  min-width: 0;

  .logo {
    width: 60rpx;
    height: 60rpx;
    flex-shrink: 0;
    background: url("#{$url}/1744272592713.png") center / 100% no-repeat;
  }

  .text {
    font-size: 30rpx;
    color: #FFFFFF;
    line-height: 36rpx;
    word-break: break-all;
  }
}
</style>
